import React from 'react';
import { Page } from '../Page';
export function Page2() {
  return <Page pageNumber={6} variant="light" data-id="element-783" data-mp="2i4s56tv7fe32">
      <div className="flex flex-col h-full" data-id="element-784" data-mp="16p1th9oihnt4">
        {/* Accent image strip */}
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-785" data-mp="11oe3mrc0rd0h">
          <img src="https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1000&q=80" alt="Healthy food spread" className="w-full h-full object-cover object-center" data-id="element-786" data-mp="wpugwoplpx72" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-787" data-mp="nwzcfx7yk5ic" />
        </div>

        <div className="mb-8" data-id="element-788" data-mp="iz7hsvfxi5ag">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-789" data-mp="iwblfbjqboo4">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-790" data-mp="90roqmxcclyb">
            The <span className="text-tealslate" data-id="element-791" data-mp="4ywq5q6somo8">Fundamentals</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-792" data-mp="510s42l4vblv" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-12" data-id="element-793" data-mp="30z8y0v8soc8b">
          <div className="space-y-4" data-id="element-794" data-mp="35qh71q67pvky">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-795" data-mp="35ris8ngxzyge">
              Traditional nutrition advice starts with calories. Count them, cut
              them, track them. Everything else comes second. For most people,
              that's still the playbook.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-796" data-mp="3jq8mlvcdnk12">
              But GLP-1 medication flips the script. The medication is already
              creating your caloric deficit by reducing appetite and slowing
              digestion. So calories move to the bottom of the list.
            </p>
          </div>
          <div className="space-y-4" data-id="element-797" data-mp="3epufqgmiig4m">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-798" data-mp="1zaomitm0cfxl">
              That changes everything. Now you build from the ground up.
              Protein, vitamins, omega-3s, fiber, and weight lifting become your
              foundation. These are the nutrients and habits that protect your
              muscle, your energy, and your health while the medication handles
              the rest.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-799" data-mp="386vkt27drp">
              All five are equally important. They are not ranked. They work
              together. And you can realistically start all of them today.
            </p>
          </div>
        </div>

        {/* Pyramid */}
        <div className="flex-1 flex flex-col items-center justify-center space-y-3 w-full max-w-lg mx-auto" data-id="element-800" data-mp="3i9csvqmq36hr">
          <div className="w-1/3 bg-tealslate text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-801" data-mp="3da095er5efje">
            Protein
          </div>
          <div className="w-1/2 bg-[#7A9BA5] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-802" data-mp="38cgpu0flfckl">
            Vitamins & Minerals
          </div>
          <div className="w-2/3 bg-[#6B8A94] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-803" data-mp="16k21aiijn9v7">
            Omega-3 Fatty Acids
          </div>
          <div className="w-5/6 bg-[#5C7983] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-804" data-mp="1f0b3h5cje65w">
            Fiber
          </div>
          <div className="w-full bg-[#4D6872] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-805" data-mp="1nt4m9cr6znoi">
            Weight Lifting
          </div>
        </div>
      </div>
    </Page>;
}